export enum ReportOption {
	STARTDATE = "start date",
	ENDDATE = "end date",
	STARTTIME = "start time",
	ENDTIME = "end time",
	EMPLOYEE = "employee",
	JOB = "job",
	MENUITEM = "menu item",
	ORDERTYPE = "order type",
	PAYMENT = "payment type",
	REVENUECENTER = "revenue center",
}
